<template>
  <section class="py-5" id="empresas">
    <div class="container py-md-5">
      <h1 class="text-left mb-4 nunito EmpresaBusquedaTitle">
        <strong class="emp-disponibles">Empresas disponibles:</strong>
        <img :src="imagen" class="EmpresasBusquedaIconoRubro" />
        <strong class="color-primary">{{nombre}}</strong>
      </h1>

      <div class="CobroResultList" v-for="item in empresas" v-bind:key="item.EntityID">{{item.Name}}</div>
      <br />
      <div class="text-center">
        <button
          class="btn btn-transparent-primary"
          style="background-color:#fff;"
          @click="nuevaClicked"
        >Nueva búsqueda</button>
      </div>
    </div>
  </section>
</template>

<style scoped src="@/assets/css/site.css">
</style>

<style>
@import "https://fonts.googleapis.com/css?family=Roboto:300,400&display=swap";
@import "https://fonts.googleapis.com/css?family=Nunito:400,600&display=swap";

.CobroResultList {
  font-size: 20px;
  margin: 0px;
  padding-bottom: 10px;
  padding-top: 10px;
  border-bottom: 1px dotted #d0d0d0;
}

.EmpresaBusquedaTitle {
  border-bottom: 2px solid #d0d0d0;
  padding-bottom: 5px;
}

.EmpresasBusquedaIconoRubro {
  width: 50px;
  margin-top: -15px;
}
.emp-disponibles {
  color: #5b5b5b !important;
}
</style>

<script>
import $ from "jquery";

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

export default {
  props: {
    CategoriaID: Number
  },
  data() {
    return {
      empresas: [],
      nombre: "",
      imagen: ""
    };
  },
  beforeMount: function() {
    let context = this;
    axiosHelpers.axiosGet(
      "Article/GetCEArticlesByCategory",
      { CategoryID: this.CategoriaID },
      this,
      function(data) {
        context.empresas = data.ResponseVM.Items;
        context.nombre = data.ResponseVM.Name;
        context.imagen = data.ResponseVM.Image;

        window.scrollTo(0,0);
      }
    );
  },
  mounted: function() {
    var topMenuHeight = $("#mainNav").outerHeight()+1;
    
    $(".scroll-link").bind("click", function(e) {
      var href = $(this).attr("href");
      var offsetTop =
        href === "#" ? 0 : $(href).offset().top - topMenuHeight + 1;
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: offsetTop
          },
          850
        );

      e.preventDefault();
    });
  },
  methods: {
    nuevaClicked() {
         window.location.href = '/#impuestos';
    //   this.$router.push({ path: "/#impuestos" });
    }
  }
};
</script>